import axios from 'axios'
import store from '../../store'

const apiAxios = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  'Content-Type': 'application/json',
})

// 5 minute timeout
apiAxios.defaults.timeout = 300000  // 5 minutes

apiAxios.interceptors.request.use((request) => {
  const accessToken = store.getters.token
  if (accessToken) {
    request.headers.Authorization = 'Token ' + accessToken
  } else if (localStorage.getItem('token')) {
    request.headers.Authorization = 'Token ' + localStorage.getItem('token')
  }
  return request
}, error => {
  return Promise.reject(error)
})


export default apiAxios